import { render, staticRenderFns } from "./TotalGeneralBudget.vue?vue&type=template&id=306c6ad0&"
import script from "./TotalGeneralBudget.vue?vue&type=script&lang=js&"
export * from "./TotalGeneralBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports